/*
 * Mazie Days: "Complete Your {X}" add-on (main-product block `md_addon`).
 * - Colour <select> swaps the add-on thumbnail + "+$24" price.
 * - When ticked, the main Add To Cart button shows bag + add-on total.
 * - On submit, the add-on (+ optional free gift) is added via /cart/add.js first, then the form is
 *   re-submitted so the theme's own add-to-cart flow adds the bag (variant, selling plan, properties intact).
 * Vanilla JS. Uses theme.Shopify.formatMoney from theme.js when available.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function') {
      return theme.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function formatShort(cents) {
    var fmt = window.theme && theme.money_format;
    return formatMoney(cents, fmt).replace(/[.,]00(?!\d)/, '');
  }

  function initAddon(root) {
    if (root.dataset.mdAddonReady) return;
    root.dataset.mdAddonReady = 'true';

    var form = document.getElementById(root.dataset.formId);
    var check = root.querySelector('[data-md-addon-check]');
    var select = root.querySelector('[data-md-addon-select]');
    var priceEl = root.querySelector('[data-md-addon-price]');
    if (!form || !check || !select) return;

    var variants = [];
    var productJson = document.getElementById('cc-product-json-' + root.dataset.productId);
    if (productJson) {
      try {
        variants = JSON.parse(productJson.textContent).variants || [];
      } catch (err) {
        variants = [];
      }
    }

    function addonOption() {
      return select.tagName === 'SELECT' ? select.options[select.selectedIndex] : select;
    }

    function addonPrice() {
      var opt = addonOption();
      return opt ? parseInt(opt.dataset.price, 10) || 0 : 0;
    }

    function bagPrice() {
      // md-personalize.js sets this when the Pet Portrait (CUSTOM product) option is chosen
      if (form.dataset.mdBasePrice) return parseInt(form.dataset.mdBasePrice, 10);
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(idInput.value)) return variants[i].price;
      }
      return null;
    }

    function submitButton() {
      return form.querySelector('[type="submit"][name="add"]');
    }

    // Button total: theme.js rewrites the button on variant change; re-apply the total after it does.
    function updateButtonTotal() {
      var btn = submitButton();
      var money = btn && btn.querySelector('.theme-money');
      var base = bagPrice();
      if (!money || base === null) return;
      var total = base + (check.checked ? addonPrice() : 0);
      var text = formatMoney(total, window.theme && theme.money_format_with_code_preference);
      if (money.innerHTML !== text) money.innerHTML = text;
    }

    function updateSelection() {
      var id = String(select.value);
      root.querySelectorAll('[data-md-addon-media]').forEach(function (el) {
        el.hidden = el.dataset.mdAddonMedia !== id;
      });
      if (priceEl) priceEl.textContent = '+' + formatShort(addonPrice());
      updateButtonTotal();
    }

    check.addEventListener('change', updateButtonTotal);
    form.addEventListener('md:base-price', updateButtonTotal);
    if (select.tagName === 'SELECT') select.addEventListener('change', updateSelection);

    var btn = submitButton();
    if (btn && 'MutationObserver' in window) {
      new MutationObserver(updateButtonTotal).observe(btn, { childList: true, subtree: true, characterData: true });
    }

    // Capture on document runs before the theme's jQuery submit handler on the form.
    var bypass = false;
    document.addEventListener('submit', function (event) {
      if (event.target !== form || bypass || !check.checked) return;
      event.preventDefault();
      event.stopPropagation();

      var items = [{ id: Number(select.value), quantity: 1 }];
      if (root.dataset.giftVariantId) {
        items.push({ id: Number(root.dataset.giftVariantId), quantity: 1 });
      }

      var button = submitButton();
      if (button) button.setAttribute('disabled', 'disabled');

      fetch(root.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          if (button) button.removeAttribute('disabled');
          bypass = true;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(button || undefined);
          } else {
            form.submit();
          }
          bypass = false;
        })
        .catch(function (error) {
          if (button) button.removeAttribute('disabled');
          var message = form.querySelector('.error-message');
          if (message) {
            message.innerText = (error && (error.description || error.message)) || 'Could not add the add-on to your cart.';
            message.style.display = 'block';
          }
        });
    }, true);

    updateButtonTotal();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-md-addon]').forEach(initAddon);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
